<template>
  <v-layout column>
    <v-flex>
      <v-layout row>
        <v-flex md7>
          <h2 style="color: #C4FD42" class="display-2 mt-2 ml-2">{{ testi.contattaci }}</h2>
          <v-layout>
            <v-flex xs6 class="ma-2">
              <v-text-field
                v-model="nome"
                :rules="altroRules"
                color="#C4FD42"
                :label="testi.nome"
                required
              ></v-text-field>
              <v-text-field
                v-model="email"
                :rules="emailRules"
                color="#C4FD42"
                label="E-mail"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs6 class="ma-2">
              <v-text-field
                v-model="cognome"
                :rules="altroRules"
                color="#C4FD42"
                :label="testi.cognome"
                required
              ></v-text-field>
              <v-text-field
                v-model="azienda"
                :rules="altroRules"
                color="#C4FD42"
                :label="testi.azienda"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout mx-2>
            <v-textarea
              v-model="oggetto"
              solo
              no-resize
              clearable
              color="#C4FD42"
              style="width: 100%;"
              :label="testi.oggetto"
            />
          </v-layout>
          <v-btn large light style="width: 98%" color="#C4FD42">{{ testi.invia }}</v-btn>
        </v-flex>

        <v-flex md5>
          <h2 style="color: #C4FD42" class="display-2 mt-2 ml-2">{{ testi.contatti }}</h2>
          <v-list class="transparent">
            <v-list-tile class="mb-2">
              <v-list-tile-avatar color="#C4FD42">
                <v-icon light color="grey darken-4">email</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-title>EMAIL</v-list-tile-title>
              <v-list-tile-sub-title>flucom@flucom.it</v-list-tile-sub-title>
            </v-list-tile>
            <v-list-tile class="mb-2">
              <v-list-tile-avatar color="#C4FD42">
                <v-icon light color="grey darken-4">map</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-title>{{ testi.indirizzo.toUpperCase() }}</v-list-tile-title>
              <v-list-tile-sub-title>Via Isacchi 1 , 42124 Reggio Emilia</v-list-tile-sub-title>
            </v-list-tile>
            <v-list-tile class="mb-2">
              <v-list-tile-avatar color="#C4FD42">
                <v-icon light color="grey darken-4">phone</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-title>{{ testi.telefono.toUpperCase() }}</v-list-tile-title>
              <v-list-tile-sub-title>+39 0522 30 65 36</v-list-tile-sub-title>
            </v-list-tile>
            <v-list-tile class="mb-2">
              <v-list-tile-avatar color="#C4FD42">
                <v-icon center light color="grey darken-4">phone</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-title>{{ testi.telefono.toUpperCase() }}</v-list-tile-title>
              <v-list-tile-sub-title>+39 0522 30 32 71</v-list-tile-sub-title>
            </v-list-tile>
            <v-list-tile class="mb-2">
              <v-list-tile-avatar color="#C4FD42">
                <v-icon light color="grey darken-4">print</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-title>FAX</v-list-tile-title>
              <v-list-tile-sub-title>+39 0522 30 69 82</v-list-tile-sub-title>
            </v-list-tile>
            <v-list-tile v-if="lingua.value === 'it'">
              <v-list-tile-avatar color="#C4FD42">
                <v-icon light color="grey darken-4">more</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-title>CODICE UFFICIO</v-list-tile-title>
              <v-list-tile-sub-title>T04ZHR3</v-list-tile-sub-title>
            </v-list-tile>
          </v-list>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex class="text-xs-center">
      <v-img src="@/assets/logopiccolo.png" contain height="160"/>
      <h1 class="font-weight-thin display-3" style="color: #C4FD42;">
        <em>passion for the hydraulic motion</em>
      </h1>
    </v-flex>
  </v-layout>
</template>
<script>
import { testiIt } from "../data_it.js";
import { testiEn } from "../data_en.js";

export default {
  data: () => ({
    valid: false,
    email: "",
    azienda: "",
    nome: "",
    cognome: "",
    oggetto: "",
    emailRules: [
      v => !!v || "E-mail obbligatoria",
      v => /.+@.+/.test(v) || "E-mail deve essere valida"
    ]
  }),
  computed: {
    testi: function() {
      if (this.lingua.value === "it") return testiIt;
      else return testiEn;
    }
  }
};
</script>